export const SET_TOKEN_MSG = 'SET_TOKEN_MSG'
export const SHOW_TOKEN_MSG = 'SHOW_TOKEN_MSG'

const state = {
  showTokenMsg: false
}
const actions = {
}
const mutations = {
  [SET_TOKEN_MSG] (state, data) {
    state.showTokenMsg = data
  }
}

const getters = {
  [SHOW_TOKEN_MSG] (state, data) {
    return state.showTokenMsg
  }
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true // 多模組的時候，當有相同名稱的變數或方法才能區隔開
}



// WEBPACK FOOTER //
// ./src/store/modules/msg.js